function _assert_this_initialized(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function _call_super(_this, derived, args) {
    derived = _get_prototype_of(derived);
    return _possible_constructor_return(_this, _is_native_reflect_construct() ? Reflect.construct(derived, args || [], _get_prototype_of(_this).constructor) : derived.apply(_this, args));
}
function _class_call_check(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _create_class(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _get_prototype_of(o) {
    _get_prototype_of = Object.setPrototypeOf ? Object.getPrototypeOf : function getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _get_prototype_of(o);
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) _set_prototype_of(subClass, superClass);
}
function _possible_constructor_return(self, call) {
    if (call && (_type_of(call) === "object" || typeof call === "function")) {
        return call;
    }
    return _assert_this_initialized(self);
}
function _set_prototype_of(o, p) {
    _set_prototype_of = Object.setPrototypeOf || function setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _set_prototype_of(o, p);
}
function _type_of(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
}
function _is_native_reflect_construct() {
    try {
        var result = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (_) {}
    return (_is_native_reflect_construct = function() {
        return !!result;
    })();
}
import BaseSchema from './schema';
import { boolean as locale } from './locale';
import isAbsent from './util/isAbsent';
export function create() {
    return new BooleanSchema();
}
var BooleanSchema = /*#__PURE__*/ function(BaseSchema) {
    "use strict";
    _inherits(BooleanSchema, BaseSchema);
    function BooleanSchema() {
        _class_call_check(this, BooleanSchema);
        var _this;
        _this = _call_super(this, BooleanSchema, [
            {
                type: 'boolean'
            }
        ]);
        _this.withMutation(function() {
            _this.transform(function(value) {
                if (!this.isType(value)) {
                    if (/^(true|1)$/i.test(String(value))) return true;
                    if (/^(false|0)$/i.test(String(value))) return false;
                }
                return value;
            });
        });
        return _this;
    }
    _create_class(BooleanSchema, [
        {
            key: "_typeCheck",
            value: function _typeCheck(v) {
                if (v instanceof Boolean) v = v.valueOf();
                return typeof v === 'boolean';
            }
        },
        {
            key: "isTrue",
            value: function isTrue() {
                var message = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : locale.isValue;
                return this.test({
                    message: message,
                    name: 'is-value',
                    exclusive: true,
                    params: {
                        value: 'true'
                    },
                    test: function(value) {
                        return isAbsent(value) || value === true;
                    }
                });
            }
        },
        {
            key: "isFalse",
            value: function isFalse() {
                var message = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : locale.isValue;
                return this.test({
                    message: message,
                    name: 'is-value',
                    exclusive: true,
                    params: {
                        value: 'false'
                    },
                    test: function(value) {
                        return isAbsent(value) || value === false;
                    }
                });
            }
        }
    ]);
    return BooleanSchema;
}(BaseSchema);
export { BooleanSchema as default };
create.prototype = BooleanSchema.prototype;
